@charset "UTF-8";

/* src/app/shared/clearing/clearing-duplicates-panel/clearing-duplicates-panel.component.scss */
:host {
  margin: 0 0 20px;
  width: 100%;
}
.mat-expansion-panel {
  border: 1px solid var(--color-accent);
  border-radius: 0;
  box-shadow: none;
}
.cw-button-wrapper {
  justify-content: space-between;
}
.cw-button-wrapper button {
  margin: 0;
  width: calc(50% - 5px);
  white-space: normal;
}
.cw-button-wrapper button {
  margin: 0 0 10px;
}
.cw-button-wrapper button:last-of-type,
.cw-button-wrapper button:nth-last-of-type(2):not(:nth-child(even)) {
  margin: 0;
}
.mat-expansion-panel-header[aria-disabled=true] .mat-expansion-panel-header-title,
.mat-expansion-panel-header[aria-disabled=true] .mat-expansion-panel-header-description {
  color: rgba(0, 0, 0, 0.87);
}
/*# sourceMappingURL=clearing-duplicates-panel.component.css.map */
